import { render, staticRenderFns } from "./BaseRatingFivePoint.vue?vue&type=template&id=d8733054"
import script from "./BaseRatingFivePoint.vue?vue&type=script&lang=js"
export * from "./BaseRatingFivePoint.vue?vue&type=script&lang=js"
import style0 from "./BaseRatingFivePoint.vue?vue&type=style&index=0&id=d8733054&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports